import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';

export interface Message {
  id: number;
  conversationId: string;
  sender: string;
  senderAvatar: string;
  content: string;
  time: string;
  isRead: boolean;
  isYou: boolean;
  type: 'text' | 'image' | 'file';
  fileUrl?: string;
  fileName?: string;
  fileSize?: number;
  replyToId?: number;
  replyToContent?: string;
  replyToSender?: string;
  status?: 'sent' | 'delivered' | 'read';
}

export interface Conversation {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  position: string;
  profilePictureKey: string;
  pictureTransform: number;
  isOnline?: boolean;
  lastMessage: string;
  lastMessageSender: string;
  time: string;
  unreadCount: number;
  isPinned?: boolean;
  isTyping?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor(private apiService: ApiService) { }

  // Get all conversations
  getConversations(): Observable<any> {
    return this.apiService.get(`/message-v2/conversations`);
  }

  // Get conversation by username
  getConversationByUsername(userName: string): Observable<any> {
    return this.apiService.get(`/message-v2/user-lists/${userName}`);
  }

  // 🔹 Get messages for a conversation (non-paginated)
  getMessages(conversationId: string): Observable<any> {
    return this.apiService.get(`/message-v2/conversations/${conversationId}/messages`);
  }

  // 🔹 Get messages with pagination
  getMessagesPaginated(conversationId: string, page: number, limit: number): Observable<any> {
    return this.apiService.get(
      `/message-v2/conversations/${conversationId}/messages?page=${page}&limit=${limit}`
    );
  }

  // Send a message
  sendMessage(conversationId: string, message: any): Observable<any> {
    return this.apiService.post(`/message-v2/conversations/${conversationId}/messages`, message);
  }

  // Mark messages as read
  markMessagesAsRead(conversationId: string): Observable<any> {
    return this.apiService.post(`/message-v2/conversations/${conversationId}/messages/read`, {});
  }

  // Create new conversation
  createConversation(participantIds: string[]): Observable<any> {
    return this.apiService.post(`/message-v2/conversations`, { participantIds });
  }

  // Search messages in conversation
  searchMessages(conversationId: string, query: string): Observable<any> {
    return this.apiService.get(`/message-v2/conversations/${conversationId}/search?q=${encodeURIComponent(query)}`);
  }

  // Upload file
  uploadFile(conversationId: string, file: FormData): Observable<any> {
    return this.apiService.post(`/message-v2/conversations/${conversationId}/upload`, file);
  }
}

